var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "R\\xE9teg_5",
    "data-name": "R\\xE9teg 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109.95478 98.50713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8dadce;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #97b51b;\n      }\n\n      .cls-4 {\n        fill: #1d4b85;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.85336,
    y: 48.04459,
    width: 92.19331,
    height: 44.79643,
    rx: 5.79381,
    transform: "translate(77.3115 -30.6831) rotate(63.16941)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.95647,
    y: 48.04459,
    width: 92.19331,
    height: 44.79643,
    rx: 5.79381,
    transform: "translate(81.20859 -37.02153) rotate(63.16941)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.60198,
    y: 48.04459,
    width: 92.19331,
    height: 44.79643,
    rx: 5.79381,
    transform: "translate(85.40327 -43.84396) rotate(63.16941)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 31.95008,
    y: 48.04459,
    width: 92.19331,
    height: 44.79643,
    rx: 5.79381,
    transform: "translate(90.53206 -52.18569) rotate(63.16941)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 40.20261,
    y: 48.04459,
    width: 92.19331,
    height: 44.79643,
    rx: 5.79381,
    transform: "translate(95.05978 -59.54979) rotate(63.16941)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/app_logo.2fccb5dcb8237aea32297428dcd5883f.svg";
export { ForwardRef as ReactComponent };